
import React from "react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { updateUserPremiumStatus } from "@/utils/admin/premium";

interface TherapistPremiumToggleProps {
  therapistId: string;
  isPremium: boolean;
  onToggle?: (isPremium: boolean) => void;
}

export const TherapistPremiumToggle = ({ therapistId, isPremium, onToggle }: TherapistPremiumToggleProps) => {
  const handleToggle = async (checked: boolean) => {
    try {
      console.log(`Updating premium status for ${therapistId} to ${checked}`);
      
      const { success, error } = await updateUserPremiumStatus(therapistId, checked);

      if (!success) {
        console.error('Error updating premium status:', error);
        toast.error(`Failed to update premium status: ${error?.message || 'Unknown error'}`);
        return;
      }

      console.log('Premium status updated successfully');
      toast.success(`Premium status ${checked ? 'enabled' : 'disabled'}`);
      onToggle?.(checked);
    } catch (error) {
      console.error('Error updating premium status:', error);
      toast.error('Failed to update premium status');
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={isPremium}
        onCheckedChange={handleToggle}
      />
      <span className="text-sm text-gray-600">
        Premium
      </span>
    </div>
  );
};
